import heic2any from 'heic2any';

export async function convertHeicToJpeg(file) {
  try {
    // Проверяем, является ли файл HEIC
    if (!file.type.includes('heic') && !file.name.toLowerCase().endsWith('.heic')) {
      throw new Error('Not a HEIC file');
    }

    // Конвертируем HEIC в Blob
    const jpegBlob = await heic2any({
      blob: file,
      toType: 'image/jpeg',
      quality: 0.85
    });

    // Создаем URL для скачивания
    const url = URL.createObjectURL(jpegBlob);
    
    // Генерируем новое имя файла
    const originalName = file.name.split('.')[0];
    const newName = `${originalName}.jpeg`;

    return {
      url,
      name: newName,
      size: jpegBlob.size
    };
  } catch (error) {
    console.error('Error converting HEIC to JPEG:', error);
    throw error;
  }
}
